// extracted by mini-css-extract-plugin
export default {"reviewer":"style_reviewer__Aq0QP","reviewer__name":"style_reviewer__name__Gr1rK","reviewerName":"style_reviewer__name__Gr1rK"};